$(document).ready(function() {    
    // Confirm Delete Modal
    $('#confirmDelete').on('show.bs.modal', function(e) {
        const message = $(e.relatedTarget).attr('data-message');
        const title = $(e.relatedTarget).attr('data-title');
        const form = $(e.relatedTarget).closest('form');

        const dataId = $(e.relatedTarget).attr('data-id');
        if (dataId && $('#Input_item_id').length > 0) {
            $('#Input_item_id').val(dataId);
        }        

        $(this).find('.modal-body p').text(message);
        $(this).find('.modal-title').text(title);
        $(this).find('.modal-footer #confirm').data('form', form);
    });

    $('#confirmDelete').find('.modal-footer #confirm').on('click', function() {
        $(this).data('form').submit();
    });

    // Confirm Delete/REVOKE Modal
    $('#confirmDeleteRevoke').on('show.bs.modal', function(e) {
        let message1 = $(e.relatedTarget).attr('data-message-1');
        let message2 = $(e.relatedTarget).attr('data-message-2');
        let title = $(e.relatedTarget).attr('data-title');
        let form = $(e.relatedTarget).closest('form');

        $(this).find('.modal-body .question').html(message1);
        $(this).find('.modal-body .message').html(message2);

        $(this).find('.modal-title').text(title);
        $(this).find('.modal-footer #delete').data('form', form);
        $(this).find('.modal-footer #revoke').data('form', form);
    });

    $('#confirmDeleteRevoke').find('.modal-footer #delete').on('click', function() {
        let extraform = $(this).parent().find('form input#action-del');
        let form = $(this).data('form').append(extraform);

        form.submit();
    });

    $('#confirmDeleteRevoke').find('.modal-footer #revoke').on('click', function() {
        let extraform = $(this).parent().find('form input#action-rev');
        let form = $(this).data('form').append(extraform);

        form.submit();
    });

    // Confirm Save Modal
    $('#confirmSave').on('show.bs.modal', function(e) {
        let message = $(e.relatedTarget).attr('data-message');
        let title = $(e.relatedTarget).attr('data-title');
        let form = $(e.relatedTarget).closest('form');

        form.find('input#password.remove-field').val('');

        $(this).find('.modal-body p').text(message);
        $(this).find('.modal-title').text(title);
        $(this).find('.modal-footer #confirm').data('form', form);
    });

    $('#confirmSave').find('.modal-footer #confirm').on('click', function() {
        $(this).data('form').submit();
    });

    // Edit Rep Modal
    $('.btn-change-pw').click((event) => {
        event.preventDefault();
        target = $(event.currentTarget);

        $('.pw-change-container').slideToggle(100);
        target.find('.fa').toggleClass('fa-times');
        target.find('.fa').toggleClass('fa-lock');

        let text = target.find('span').text();
        target.find('span').text(
            text == '' ? 'Cancel' : '');
        $('input#password').toggleClass('remove-field');

    });

    $('input').keyup((event) => {
        target = $(event.currentTarget);
        checkChanged(target);
    });

    $('select').change((event) => {
        target = $(event.currentTarget);
        checkChanged(target);
    });

    function checkChanged(item) {
        if (!item.val()) {
            $('.btn-save').hide();
        } else {
            $('.btn-save').show();
        }
    }
    // Register new user
    $('.register').click(function() {
        $('#register').show();
    });

    $('#register .body .exit').click(function() {
        $('#register').hide();
    });
});
